import toast from 'react-hot-toast';
import { useSWRConfig } from 'swr';
import { captureException } from '@sentry/react';

import { Dialog } from '../../../components/dialog/Dialog';
import { createLocation, LOCATIONS_SWR_KEY } from '../models';
import type { CreateLocationResponse } from '../endpoints/CreateLocationEndpoint.types';
import { getDisplayError } from '../../../utils/get-display-error';
import { trackEvent } from '../../../utils/track-event';
import { CreateLocationForm } from './CreateLocationForm';

export interface ICreateLocationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreated: (created: CreateLocationResponse) => void;
  initialName?: string;
}

export const CreateLocationDialog: React.FC<ICreateLocationDialogProps> = (props) => {
  const { isOpen, onClose, onCreated, initialName } = props;
  const { mutate } = useSWRConfig();

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Nieuwe locatie">
      <CreateLocationForm
        initialName={initialName}
        onCancel={onClose}
        onSubmit={async (inputData) => {
          try {
            const result = await createLocation(inputData);
            trackEvent('location_created', {
              location_id: result.id,
              country: inputData.country,
            });
            // The combobox's list cache is now stale — reopening it should show the new location.
            await mutate((key) => Array.isArray(key) && key[0] === LOCATIONS_SWR_KEY);
            onCreated(result);
            toast.success('Locatie aangemaakt');
          } catch (err: any) {
            captureException(err);
            toast.error('Kon locatie niet aanmaken: ' + getDisplayError(err));
          }
        }}
      />
    </Dialog>
  );
};
